export function selectAuthAwareRoutePath({
  currentPath,
  hasEvidenceRole,
  hasLiveProfile
}: {
  currentPath: string;
  hasEvidenceRole: boolean;
  hasLiveProfile: boolean;
}) {
  if (hasEvidenceRole) return currentPath;
  if (hasLiveProfile) return currentPath === "/login" ? "/dashboard" : currentPath;
  return "/login";
}
